export const WIEGAND_SITE_CODE = "BIO_WIEGAND_SITE_CODE";
export const WIEGAND_ID_FORMAT = "BIO_WIEGAND_ID_FORMAT";
export const WIEGAND_SITE_FORMAT = "BIO_WIEGAND_SITE_FORMAT";
export const WIEGAND_STOP_FORMAT = "BIO_WIEGAND_STOP_FORMAT";
export const WIEGAND_START_FORMAT = "BIO_WIEGAND_START_FORMAT";
export const WIEGAND_FRAME_LENGTH = "BIO_WIEGAND_FRAME_LENGTH";
export const WIEGAND_SEND_ID_ENABLED = "BIO_WIEGAND_ENABLED";

export const BIO_CID_CARD_IDENTIFICATION_ENABLED = "BIO_CID_CARD_IDENTIFICATION_ENABLED";
export const BIO_CID_FACE_IDENTIFICATION_ENABLED = "BIO_CID_FACE_IDENTIFICATION_ENABLED";
export const BIO_CID_QR_CODE_IDENTIFICATION_ENABLED = "BIO_CID_QR_CODE_IDENTIFICATION_ENABLED";
export const BIO_CID_PIN_IDENTIFICATION_ENABLED = "BIO_CID_PIN_IDENTIFICATION_ENABLED";
export const BIO_CID_MULTI_FACTOR_AUTH_ACCESS = "BIO_CID_MULTI_FACTOR_AUTH_ACCESS";
export const BIO_CID_MULTI_FACTOR_AUTH_FACE = "BIO_CID_MULTI_FACTOR_AUTH_FACE";
export const BIO_CID_SIMILARITY_THRESHOLD_1ton = "BIO_CID_SIMILARITY_THRESHOLD_1ton";
export const BIO_CID_ENABLE_BUZZER = "BIO_CID_ENABLE_BUZZER";

export const BIO_TCPIP_HOST_PORT = "BIO_TCPIP_HOST_PORT";
export const BIO_TCPIP_POOL_COUNT = "BIO_TCPIP_POOL_COUNT";
export const BIO_TCPIP_EXTENDED_TIMEOUT = "BIO_TCPIP_EXTENDED_TIMEOUT";
export const BIO_FAST_UPLOAD_MA100 = "BIO_FAST_UPLOAD_MA100";
export const BIO_FAST_UPLOAD_JSERIES = "BIO_FAST_UPLOAD_JSERIES";
export const BIO_FULL_UPLOAD_RETRIES = "BIO_FULL_UPLOAD_RETRIES";
export const BIO_LOGGING_THRESHOLD = "BIO_LOGGING_THRESHOLD";
export const BIO_CARD_READ_SUPPORT = "BIO_CARD_READ_SUPPORT";
export const BIO_SUCCESS_MESSAGE_CONTENT = "BIO_SUCCESS_MESSAGE_CONTENT";
export const BIO_TIMESYNCH_ENABLED_FULL_UPLOAD = "BIO_TIMESYNCH_ENABLED_FULL_UPLOAD";
export const BIO_TIMESYNCH_ENABLED_GENERAL = "BIO_TIMESYNCH_ENABLED_GENERAL";
export const BIO_VERIFY_USER_ID = "BIO_VERIFY_USER_ID";

export const BIO_THREAT_LEVEL_OFF = "BIO_THREAT_LEVEL_OFF";
export const BIO_THREAT_LEVEL_LOW = "BIO_THREAT_LEVEL_LOW";
export const BIO_THREAT_LEVEL_ELEVATED = "BIO_THREAT_LEVEL_ELEVATED";
export const BIO_THREAT_LEVEL_HIGH = "BIO_THREAT_LEVEL_HIGH";

export const BIO_CHECK_HOLIDAY_SCHEDULE = "BIO_CHECK_HOLIDAY_SCHEDULE";
export const BIO_ENABLE_EXTERNAL_DATABASE = "BIO_ENABLE_EXTERNAL_DATABASE";
export const BIO_CHECK_ACCESS_SCHEDULE = "BIO_CHECK_ACCESS_SCHEDULE";
export const BIO_CHECK_EXPIRY_DATE = "BIO_CHECK_EXPIRY_DATE";
export const BIO_CHECK_STOLEN_CARD_LIST = "BIO_CHECK_STOLEN_CARD_LIST";
export const BIO_CSN_LENGTH = "BIO_CSN_LENGTH";

export const BIO_CUSTOM_PROPERTIES_INT32 = "BIO_CUSTOM_PROPERTIES_INT32";

export const BIO_TNA_EXTENDED_MODE = "BIO_TNA_EXTENDED_MODE";
export const BIO_TNA_MANDATORY_MODE = "BIO_TNA_MANDATORY_MODE";
export const BIO_TNA_MODE = "BIO_TNA_MODE";
export const BIO_TNA_TEXT_MODE = "BIO_TNA_TEXT_MODE";
export const BIO_TNA_TIMEOUT = "BIO_TNA_TIMEOUT";
export const BIO_TNA_USER_CONTROL = "BIO_TNA_USER_CONTROL";

export const BIO_TNA_BTN_CONFIG_SETTINGS = "BIO_TNA_BTN_CONFIG";

// Control iD fields
export const CONTROL_ID_FIELDS = {
    WIEGAND_CID_POSITION_MOST_SIGNIFICANT_BIT: "BIO_CID_POSITION_MOST_SIGNIFICANT_BIT",
    WIEGAND_CID_WIEGAND_OUT_SIZE: "BIO_CID_WIEGAND_OUT_SIZE",
    WIEGAND_CID_WIEGAND_OUT_MODE: "BIO_CID_WIEGAND_OUT_MODE",
    BIO_CID_CARD_IDENTIFICATION_ENABLED: "BIO_CID_CARD_IDENTIFICATION_ENABLED",
    BIO_CID_FACE_IDENTIFICATION_ENABLED: "BIO_CID_FACE_IDENTIFICATION_ENABLED",
    BIO_CID_QR_CODE_IDENTIFICATION_ENABLED: "BIO_CID_QR_CODE_IDENTIFICATION_ENABLED",
    BIO_CID_PIN_IDENTIFICATION_ENABLED: "BIO_CID_PIN_IDENTIFICATION_ENABLED",
    BIO_CID_MULTI_FACTOR_AUTH_ACCESS: "BIO_CID_MULTI_FACTOR_AUTH_ACCESS",
    BIO_CID_MULTI_FACTOR_AUTH_FACE: "BIO_CID_MULTI_FACTOR_AUTH_FACE",
    BIO_CID_SIMILARITY_THRESHOLD_1ton: "BIO_CID_SIMILARITY_THRESHOLD_1ton",
    BIO_CID_ENABLE_BUZZER: "BIO_CID_ENABLE_BUZZER",
    BIO_CID_MASK_DETECTION_ENABLED: "BIO_CID_MASK_DETECTION_ENABLED",
    BIO_CID_ENABLE_VEHICLE: "BIO_CID_ENABLE_VEHICLE",
    BIO_CID_MAX_IDENTIFICATION_TIME: "BIO_CID_MAX_IDENTIFICATION_TIME",
    BIO_CID_LIMIT_IDENTIFICATION_VIEW: "BIO_CID_LIMIT_IDENTIFICATION_VIEW",
    BIO_CID_ZOOM: "BIO_CID_ZOOM",
    BIO_CID_VERTICAL_CROP: "BIO_CID_VERTICAL_CROP",
    BIO_CID_LED_ACTIVATION_THRESHOLD: "BIO_CID_LED_ACTIVATION_THRESHOLD",
    BIO_CID_OSDP_ENABLED: "BIO_CID_OSDP_ENABLED",
    BIO_CID_OSDP_BAUD_RATE: "BIO_CID_OSDP_BAUD_RATE",
    // BIO_CID_OSDP_ENFORCE_SECURE_CHANNEL: "BIO_CID_OSDP_ENFORCE_SECURE_CHANNEL",
    BIO_CID_OSDP_CARD_READ_FORMAT: "BIO_CID_OSDP_CARD_READ_FORMAT",
    BIO_CID_OSDP_OUTPUT_MODE: "BIO_CID_OSDP_OUTPUT_MODE",
    // BIO_CID_OSDP_INSTALLATION_MODE: "BIO_CID_OSDP_INSTALLATION_MODE",
    BIO_CID_OSDP_WIEGAND_SIZE: "BIO_CID_OSDP_WIEGAND_SIZE",
    BIO_CID_MIFARE_BYTE_ORDER: "BIO_CID_MIFARE_BYTE_ORDER",
}

export const CONTROLID_WIEGAND_FIELDS = [
    CONTROL_ID_FIELDS.WIEGAND_CID_POSITION_MOST_SIGNIFICANT_BIT, CONTROL_ID_FIELDS.WIEGAND_CID_WIEGAND_OUT_SIZE, 
    CONTROL_ID_FIELDS.WIEGAND_CID_WIEGAND_OUT_MODE, CONTROL_ID_FIELDS.BIO_CID_MIFARE_BYTE_ORDER
]

export const CONTROLID_COMMS_FIELDS = [
    CONTROL_ID_FIELDS.BIO_CID_CARD_IDENTIFICATION_ENABLED, CONTROL_ID_FIELDS.BIO_CID_FACE_IDENTIFICATION_ENABLED, 
    CONTROL_ID_FIELDS.BIO_CID_QR_CODE_IDENTIFICATION_ENABLED, CONTROL_ID_FIELDS.BIO_CID_PIN_IDENTIFICATION_ENABLED, 
    CONTROL_ID_FIELDS.BIO_CID_MULTI_FACTOR_AUTH_ACCESS, CONTROL_ID_FIELDS.BIO_CID_MULTI_FACTOR_AUTH_FACE, 
    CONTROL_ID_FIELDS.BIO_CID_SIMILARITY_THRESHOLD_1ton, CONTROL_ID_FIELDS.BIO_CID_ENABLE_BUZZER,
]

export const CONTROLID_OSDP_FIELDS = [
    CONTROL_ID_FIELDS.BIO_CID_OSDP_ENABLED,
    CONTROL_ID_FIELDS.BIO_CID_OSDP_BAUD_RATE, 
    // CONTROL_ID_FIELDS.BIO_CID_OSDP_ENFORCE_SECURE_CHANNEL,
    CONTROL_ID_FIELDS.BIO_CID_OSDP_CARD_READ_FORMAT, CONTROL_ID_FIELDS.BIO_CID_OSDP_OUTPUT_MODE,
    // CONTROL_ID_FIELDS.BIO_CID_OSDP_INSTALLATION_MODE, 
    CONTROL_ID_FIELDS.BIO_CID_OSDP_WIEGAND_SIZE
]

export const CONTROLID_FACE_FIELDS = [
    CONTROL_ID_FIELDS.BIO_CID_MAX_IDENTIFICATION_TIME, CONTROL_ID_FIELDS.BIO_CID_LIMIT_IDENTIFICATION_VIEW, 
    CONTROL_ID_FIELDS.BIO_CID_LED_ACTIVATION_THRESHOLD
]

// HikVision fields
export const HIK_FIELDS = {
    HIK_DEVICE_PORT: "BIO_HIK_DEVICE_PORT",
    HIK_WEB_PORT: "BIO_HIK_WEB_PORT",
    HIK_TIME_ZONE: "BIO_HIK_TIME_ZONE",
    HIK_TIME_MODE: "BIO_HIK_TIME_MODE",
    HIK_SKIP_TIME_SETINGS: "BIO_HIK_SKIP_TIME_SETINGS",
    HIK_UPLOAD_SETTINGS: "BIO_HIK_UPLOAD_SETTINGS",
    HIK_ENABLE_WIEGAND: "BIO_HIK_ENABLE_WIEGAND",
    HIK_WIEGAND_LENGTH: "BIO_HIK_WIEGAND_LENGTH",
    HIK_CARD_NUMBER_REVERSING: "BIO_HIK_CARD_NUMBER_REVERSING",
    HIK_CARD_LENGTH_MODE: "BIO_HIK_CARD_LENGTH_MODE",
    HIK_ENALBE_THERMAL: "BIO_HIK_ENALBE_THERMAL",
    HIK_TERMAL_MAX: "BIO_HIK_TERMAL_MAX",
    HIK_TERMAL_MIN: "BIO_HIK_TERMAL_MIN",
    HIK_DEFAULT_VERIFY_MODE: "BIO_HIK_DEFAULT_VERIFY_MODE",
    HIK_ENABLE_QR: "BIO_HIK_ENABLE_QR",
    HIK_VOICE_PROMPT: "BIO_HIK_VOICE_PROMPT",
}

export const HIK_WIEGAND_FIELDS = [
    HIK_FIELDS.HIK_ENABLE_WIEGAND,
    HIK_FIELDS.HIK_WIEGAND_LENGTH, 
    HIK_FIELDS.HIK_CARD_NUMBER_REVERSING,
    HIK_FIELDS.HIK_CARD_LENGTH_MODE
]
export const HIK_THERMAL_FIELDS = [
    HIK_FIELDS.HIK_ENALBE_THERMAL,
    HIK_FIELDS.HIK_TERMAL_MAX, 
    HIK_FIELDS.HIK_TERMAL_MIN,
]
export const HIK_COMMS_FIELDS = [
    HIK_FIELDS.HIK_DEVICE_PORT,
    HIK_FIELDS.HIK_WEB_PORT,
    HIK_FIELDS.HIK_SKIP_TIME_SETINGS,
    HIK_FIELDS.HIK_TIME_ZONE,
    HIK_FIELDS.HIK_UPLOAD_SETTINGS
]
export const HIK_AUTH_FIELDS = [
    HIK_FIELDS.HIK_DEFAULT_VERIFY_MODE,
    HIK_FIELDS.HIK_ENABLE_QR,
    HIK_FIELDS.HIK_VOICE_PROMPT
]